.dateField {
  display: inline-flex;
  flex: 1 1 auto;
  color: var(--ixf-input-font-color);
  font-size: var(--ixf-input-font-size);
  line-height: var(--ixf-input-line-height);
  font-weight: var(--ixf-input-font-weight);
  padding: var(--ixf-input-padding);

  &.isPlaceholder {
    color: var(--ixf-input-placeholder-color);
  }
}
